import React, { useEffect, useState, useRef } from "react";
import { UserContainer } from "./style";
import { Input } from "../../Login/style";
import Button from "../../../Components/Miscellaneous/Button";
import AuthService from "../../../AuthService";
import { toast } from "react-toastify";
import { MdDelete, MdAdd, MdCloudUpload, MdDragIndicator } from "react-icons/md";
import Select from 'react-select';
import axios from 'axios';

export default function HomeEditor() {
    const [slider, setSlider] = useState([]);
    const [bestSellers, setBestSellers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        fetchHomeData();
        fetchProducts();
    }, []);

    const fetchHomeData = async () => {
        try {
            const response = await fetch('https://api.rb.beeapp.es/home');
            const data = await response.json();
            setSlider(data.slider || []);
            setBestSellers(data.bestSeller || []);
            setLoading(false);
        } catch (error) {
            console.error(error);
            toast.error('Error al cargar datos');
            setLoading(false);
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await axios.get('https://api.rb.beeapp.es/admin/products?page=1&limit=1000', {
                headers: { 'Authorization': 'Bearer ' + AuthService.getToken() }
            });
            setProducts(response.data.results.map(p => ({
                value: p._id,
                label: `${p.name} (${p.reference})`
            })));
        } catch (error) {
            console.error(error);
        }
    };

    const handleImageUpload = async (file) => {
        setUploadingImage(true);
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('https://api.rb.beeapp.es/admin/imageUpload', {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + AuthService.getToken() },
                body: formData
            });
            const data = await response.json();
            setUploadingImage(false);
            return `https://cdn.beeapp.es/${data.imagename}`;
        } catch (error) {
            toast.error('Error al subir imagen');
            setUploadingImage(false);
            return null;
        }
    };

    const addSlide = async (imageUrl) => {
        try {
            await fetch('https://api.rb.beeapp.es/home/slider', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + AuthService.getToken()
                },
                body: JSON.stringify({ image: imageUrl, link: '' })
            });
            toast.success('Imagen añadida');
            fetchHomeData();
        } catch (error) {
            toast.error('Error al añadir imagen');
        }
    };

    const updateSlider = async () => {
        try {
            await fetch(`https://api.rb.beeapp.es/home/slider/${slider[0]?._id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + AuthService.getToken()
                },
                body: JSON.stringify({ slider })
            });
            toast.success('Cambios guardados');
        } catch (error) {
            toast.error('Error al guardar');
        }
    };

    const deleteSlide = async (id) => {
        if (!window.confirm('¿Eliminar esta imagen?')) return;
        try {
            await fetch(`https://api.rb.beeapp.es/home/slider/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': 'Bearer ' + AuthService.getToken() }
            });
            toast.success('Imagen eliminada');
            fetchHomeData();
        } catch (error) {
            toast.error('Error al eliminar');
        }
    };

    const addBestSeller = async () => {
        if (!selectedProduct) {
            toast.error('Selecciona un producto');
            return;
        }
        try {
            await fetch('https://api.rb.beeapp.es/home/bestseller', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + AuthService.getToken()
                },
                body: JSON.stringify({ productID: selectedProduct.value })
            });
            toast.success('Producto añadido');
            setSelectedProduct(null);
            fetchHomeData();
        } catch (error) {
            toast.error('Error al añadir');
        }
    };

    const deleteBestSeller = async (id) => {
        if (!window.confirm('¿Eliminar este producto?')) return;
        try {
            await fetch(`https://api.rb.beeapp.es/home/bestseller/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': 'Bearer ' + AuthService.getToken() }
            });
            toast.success('Producto eliminado');
            fetchHomeData();
        } catch (error) {
            toast.error('Error al eliminar');
        }
    };

    if (loading) {
        return (
            <UserContainer>
                <div style={{ padding: '60px', textAlign: 'center' }}>
                    <p style={{ color: '#9ca3af', fontSize: '0.875rem' }}>Cargando...</p>
                </div>
            </UserContainer>
        );
    }

    return (
        <UserContainer style={{ padding: '40px' }}>
            {/* Header */}
            <div style={{ marginBottom: '48px' }}>
                <h1 style={{
                    color: '#1f2937',
                    fontSize: '2rem',
                    fontWeight: '300',
                    margin: 0,
                    letterSpacing: '-0.02em'
                }}>
                    Página de Inicio
                </h1>
            </div>

            {/* Slider Section */}
            <div style={{ marginBottom: '64px' }}>
                <h2 style={{
                    color: '#6b7280',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    margin: 0,
                    marginBottom: '24px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em'
                }}>
                    Slider Principal
                </h2>

                {/* Upload Area */}
                <div
                    onClick={() => fileInputRef.current?.click()}
                    style={{
                        backgroundColor: '#fafafa',
                        border: '2px dashed #e5e7eb',
                        borderRadius: '16px',
                        padding: '48px',
                        marginBottom: '32px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        textAlign: 'center'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f9fafb';
                        e.currentTarget.style.borderColor = '#028322';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#fafafa';
                        e.currentTarget.style.borderColor = '#e5e7eb';
                    }}
                >
                    <MdCloudUpload size={48} color={uploadingImage ? '#028322' : '#d1d5db'} style={{ marginBottom: '16px' }} />
                    <p style={{ margin: 0, fontSize: '0.875rem', color: '#6b7280', marginBottom: '4px' }}>
                        {uploadingImage ? 'Subiendo imagen...' : 'Click para añadir imagen al slider'}
                    </p>
                    <p style={{ margin: 0, fontSize: '0.75rem', color: '#9ca3af' }}>
                        JPG, PNG o WEBP
                    </p>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                                const imageUrl = await handleImageUpload(file);
                                if (imageUrl) await addSlide(imageUrl);
                            }
                        }}
                        style={{ display: 'none' }}
                    />
                </div>

                {/* Slides Grid */}
                <div style={{ display: 'grid', gap: '24px' }}>
                    {slider.map((slide, index) => (
                        <div key={slide._id} style={{
                            backgroundColor: '#fff',
                            border: '1px solid #f3f4f6',
                            borderRadius: '12px',
                            padding: '20px',
                            display: 'grid',
                            gridTemplateColumns: '200px 1fr auto',
                            gap: '24px',
                            alignItems: 'center',
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)'}
                        onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                        >
                            <img src={slide.image} alt={`Slide ${index + 1}`} style={{
                                width: '100%',
                                height: '100px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                                backgroundColor: '#f9fafb'
                            }} />

                            <div>
                                <label style={{
                                    display: 'block',
                                    fontSize: '0.75rem',
                                    color: '#9ca3af',
                                    marginBottom: '8px',
                                    fontWeight: '500'
                                }}>
                                    Enlace
                                </label>
                                <Input
                                    type="text"
                                    placeholder="https://..."
                                    value={slide.link || ''}
                                    onChange={(e) => {
                                        const newSlider = [...slider];
                                        newSlider[index].link = e.target.value;
                                        setSlider(newSlider);
                                    }}
                                    style={{
                                        padding: '10px 12px',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '0.875rem'
                                    }}
                                />
                            </div>

                            <button
                                onClick={() => deleteSlide(slide._id)}
                                style={{
                                    padding: '10px',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                            >
                                <MdDelete size={20} color="#ef4444" />
                            </button>
                        </div>
                    ))}
                </div>

                {slider.length > 0 && (
                    <div style={{ marginTop: '24px', textAlign: 'right' }}>
                        <Button
                            onClick={updateSlider}
                            style={{
                                backgroundColor: '#1f2937',
                                color: 'white',
                                padding: '12px 32px',
                                fontSize: '0.875rem',
                                fontWeight: '500'
                            }}
                        >
                            Guardar cambios
                        </Button>
                    </div>
                )}
            </div>

            {/* Best Sellers Section */}
            <div>
                <h2 style={{
                    color: '#6b7280',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    margin: 0,
                    marginBottom: '24px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em'
                }}>
                    Productos Destacados
                </h2>

                {/* Add Product */}
                <div style={{
                    backgroundColor: '#fafafa',
                    border: '1px solid #f3f4f6',
                    borderRadius: '12px',
                    padding: '24px',
                    marginBottom: '32px',
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'flex-end'
                }}>
                    <div style={{ flex: 1 }}>
                        <label style={{
                            display: 'block',
                            fontSize: '0.75rem',
                            color: '#9ca3af',
                            marginBottom: '8px',
                            fontWeight: '500'
                        }}>
                            Buscar producto
                        </label>
                        <Select
                            options={products}
                            value={selectedProduct}
                            onChange={setSelectedProduct}
                            placeholder="Escribe para buscar..."
                            isClearable
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    minHeight: '44px'
                                })
                            }}
                        />
                    </div>
                    <Button
                        onClick={addBestSeller}
                        style={{
                            backgroundColor: '#028322',
                            color: 'white',
                            padding: '12px 24px',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        <MdAdd size={18} />
                        Añadir
                    </Button>
                </div>

                {/* Products Grid */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
                    {bestSellers.map((item) => (
                        <div key={item._id} style={{
                            backgroundColor: '#fff',
                            border: '1px solid #f3f4f6',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)'}
                        onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                        >
                            {item.ProductID?.images && item.ProductID.images[0] && (
                                <div style={{
                                    width: '100%',
                                    height: '200px',
                                    backgroundColor: '#f9fafb',
                                    position: 'relative'
                                }}>
                                    <img src={item.ProductID.images[0]} alt={item.ProductID.name} style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }} />
                                    <button
                                        onClick={() => deleteBestSeller(item._id)}
                                        style={{
                                            position: 'absolute',
                                            top: '12px',
                                            right: '12px',
                                            padding: '8px',
                                            backgroundColor: 'rgba(255,255,255,0.95)',
                                            border: 'none',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                        }}
                                    >
                                        <MdDelete size={18} color="#ef4444" />
                                    </button>
                                </div>
                            )}
                            <div style={{ padding: '16px' }}>
                                <p style={{
                                    margin: 0,
                                    fontSize: '0.875rem',
                                    fontWeight: '500',
                                    color: '#1f2937',
                                    marginBottom: '4px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {item.ProductID?.name || 'Producto eliminado'}
                                </p>
                                <p style={{
                                    margin: 0,
                                    fontSize: '0.75rem',
                                    color: '#9ca3af'
                                }}>
                                    {item.ProductID?.reference || '-'}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {bestSellers.length === 0 && (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px',
                        color: '#9ca3af',
                        fontSize: '0.875rem'
                    }}>
                        No hay productos destacados
                    </div>
                )}
            </div>
        </UserContainer>
    );
}
